import { EstadoMensaje } from "@shared/interfaces/apl-afiliacion.interface";

export const MENSAJES_ESTADOS: Record<number, EstadoMensaje> = {
    0: {
        estado: 'No existe',
        type: 'blue',
        text: 'Debes completar el formulario de Conocimiento de Cliente. Una vez diligenciado, regresa a este portal y espera la validación de la información registrada para completar el proceso de registro. Al dar clic en el botón Aceptar, serás redireccionado.',
        banner: false,
        button: "Aceptar"
    },
    1: {
        estado: 'Espera aprobación',
        type: 'aprobacion',
        text: 'CreadaDebidaDiligencia: Indica que la debida diligencia ha sido creada y está en espera de una aprobación o rechazo.',
        banner: true,
        imagen: "estado1.svg",
        button: "Aceptar"
    },
    2: {
        estado: 'Crear o corregir',
        type: 'success',
        text1: '¡Tienes información pendiente por diligenciar!',
        text: 'Por favor, haz',
        subtitle: 'para completar tus datos',
        banner: true,
        imagen: "estado_2.png",
        button: "Clic aquí"
    },
    3: {
        estado: 'Aprobada',
        type: 'success',
        title: '¡La validación de tu información registrada en el formulario de Conocimiento de Cliente ha sido exitosa!',
        subtitle: 'Afiliación en Línea',
        text: 'Por favor continua con el proceso de creación de tu usuario de',
        banner: false,
        button: "Aceptar"
    },
    4: {
        estado: 'Rechazada',
        type: 'error',
        text: 'RechazadaDebidaDiligencia: Indica que la debida diligencia ha sido rechazada',
        banner: true,
        imagen: "estado4.svg",
        button: "Aceptar"
    },
    5: {
        estado: 'Notificado',
        type: 'warning',
        text: 'Notificado: Indica que se debe hacer un proceso de renovación anticipada del proceso de debida diligencia ya que este se encuentra próximo a su vencimiento',
        banner: true,
        imagen: "estado_5.png",
        imagen1: "estado_5.png",
        button: "Aceptar"
    }
};

export const PRODUCTOS_TERMINIOS_CONDICIONES_DOCUMENTOS = {
    DEBIDA_DILIGENCIA: '6505d83f-b48c-4370-9995-bcd24f58cf19',
    AFILIACION: '184c4ad5-211b-48a6-9205-2c24165f1cc8'
}

export const INSTRUCCIONES_CENTROS_TRABAJO = [
    {
        sheetName: 'Instrucciones',
        data: [
            { "Sigue atentamente las instrucciones": '1. Cada centro de trabajo relacionado, corresponde a un ID, este ID debes relacionarlo en el archivo plantilla que descargas cuando vas a realizar una carga masiva de afiliaciones' },
            { "Sigue atentamente las instrucciones": '2. En la columna "AX" Centro de trabajo, debes relacionar el id del centro de trabajo al que corresponda el empleado que deseas afiliar' },
            { "Sigue atentamente las instrucciones": '3. Debes tener en cuenta que los centros de trabajo corresponden al lugar en donde tu emplead@ realizara sus labores y para el proceso de afiliacion de la ARL, esta informacion es muy importante. Por lo tanto debes asegurarte que el ID corresponda correctamente' },
            { "Sigue atentamente las instrucciones": '4. Si relacionas algun ID por error, puedes generar la afiliación y posteriormente generar la novedad de cambio de centro de trabajo' }
        ]
    }
];

export const MENSAJES_NOTIFICACION = [
    {
        reserva: {
            mensaje: `Tienes %%LIMITE_MINUTOS_FINALIZAR_RESERVA%% minutos para finalizar la afiliación`,
            duracion: 5000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
            styles: 'snackbar-green'
        },
        expira_sesion: {
            mensaje: 'Tu sesión esta proxima a expirar',
            duracion: 5000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            styles: ['snackbar-green', 'snackbar-center-text']
        },
        ley_100: {
            mensaje: 'Las afiliaciones deben radicarse sobre la base del salario mínimo vigente (Art. 204 Ley 100/1993).',
            duracion: 5000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
            styles: 'snackbar-red'
        }
    }
]

export const TIPO_DOCUMENTOS_ELIMINAR = ["RC", "CNV", "PONU"];
export const TIPO_DOCUMENTOS_ELIMINAR_BENEFICIARIOS = ["PONU"];
export const TIPO_DOCUMENTOS_ELIMINAR_REPORTE = ["NIT", "PE", "RC"];

export const VALIDACIONES_IDENTIFICACION: {
    [key: string]: {
        min: number;
        max: number;
        pattern: string;
        placeholder: string;
        hint?: string;
    };
} = {
    CC: {
        min: 6,
        max: 10,
        pattern: '^[0-9]*$',
        placeholder: 'Ingresa cédula de ciudadanía',
        hint: 'Solo números, entre 6 y 10 dígitos',
    },
    te: {
        min: 7,
        max: 7,
        pattern: '^[a-zA-Z0-9]*$',
        placeholder: 'Ingresa tarjeta de extranjería',
        hint: '7 caracteres alfanuméricos',
    },
    CE: {
        min: 7,
        max: 7,
        pattern: '^[a-zA-Z0-9]*$',
        placeholder: 'Ingresa cédula de extranjería',
        hint: '7 caracteres alfanuméricos',
    },
    CD: {
        min: 1,
        max: 10,
        pattern: '^[a-zA-Z0-9]*$',
        placeholder: 'Ingresa carnet diplomático',
        hint: 'Hasta 10 caracteres alfanuméricos',
    },
    P: {
        min: 1,
        max: 11,
        pattern: '^[a-zA-Z0-9]*$',
        placeholder: 'Ingresa pasaporte',
        hint: 'Hasta 11 caracteres alfanuméricos',
    },
    SP: {
        min: 1,
        max: 12,
        pattern: '^[a-zA-Z0-9]*$',
        placeholder: 'Ingresa salvo conducto',
        hint: 'Hasta 12 caracteres alfanuméricos',
    },
    PPT: {
        min: 1,
        max: 12,
        pattern: '^[a-zA-Z0-9]*$',
        placeholder: 'Ingresa permiso por proteccion',
        hint: 'Hasta 12 caracteres alfanuméricos',
    },
    TI: {
        min: 6,
        max: 15,
        pattern: '^[0-9]*$',
        placeholder: 'Ingresa Tarjeta de identidad',
        hint: 'Solo números, entre 6 y 15 dígitos',
    },
    RC: {
        min: 1,
        max: 11,
        pattern: '^[a-zA-Z0-9]*$',
        placeholder: 'Ingresa Registro civil de nacimiento',
        hint: 'Solo números, entre 6 y 11 dígitos',
    },
    CNV: {
        min: 6,
        max: 9,
        pattern: '^[0-9]*$',
        placeholder: 'Ingresa Certificado de nacido vivo',
        hint: 'Solo números, hasta 9 dígitos',
    },
    PA: {
        min: 1,
        max: 11,
        pattern: '^[a-zA-Z0-9]*$',
        placeholder: 'Ingresa pasaporte',
        hint: 'Hasta 11 caracteres alfanuméricos',
    },
    SC: {
        min: 1,
        max: 12,
        pattern: '^[a-zA-Z0-9]*$',
        placeholder: 'Ingresa permiso por proteccion',
        hint: 'Hasta 12 caracteres alfanuméricos',
    },
    PT: {
        min: 1,
        max: 12,
        pattern: '^[a-zA-Z0-9]*$',
        placeholder: 'Ingresa permiso por proteccion',
        hint: 'Hasta 12 caracteres alfanuméricos',
    },
};

